import React from 'react';

import SectionCard from '@/components/common/SectionCard/SectionCard';
import UploadedFilesTable from './components/UploadedFilesTable/UploadedFilesTable';
import UploadFileCard from './UploadFileCard';


export default function UploadTemplateContainer() {
  return (
    <>
      <SectionCard
        padding={true}
        title={{ titleText: 'Uplift En Masse Upload' }}
      >
        <UploadFileCard />
      </SectionCard>

      <SectionCard
        padding={true}
        title={{ titleText: 'Uplifts Uploaded' }}
        className="mt-20"
      >
        <UploadedFilesTable />
      </SectionCard>
    </>
  );
}
